"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import { cn } from "@repo/ui/utils";
import { DialogCard } from "@/components/cards/dialog-card";
import { LogoTile } from "@/components/cards/logo-tile";
import { CommercialTenantDetailPanel } from "./commercial-tenant-detail-panel.component";
import { resolvePanelContent } from "./commercial-tenant-card.helpers";
import type { CommercialTenantCardProps } from "./commercial-tenant-card.types";
export function CommercialTenantCard(t0) {
  const $ = _c(37);
  const {
    title,
    logoLight,
    address,
    tradingHours,
    bodyCopy,
    website,
    email,
    phone,
    facebook,
    instagram,
    className
  } = t0;
  const t = useTranslations("commercialTenantCard");
  let t1;
  if ($[0] !== address || $[1] !== bodyCopy || $[2] !== email || $[3] !== facebook || $[4] !== instagram || $[5] !== phone || $[6] !== tradingHours || $[7] !== website) {
    t1 = resolvePanelContent({
      address,
      tradingHours,
      bodyCopy,
      website,
      email,
      phone,
      facebook,
      instagram
    });
    $[0] = address;
    $[1] = bodyCopy;
    $[2] = email;
    $[3] = facebook;
    $[4] = instagram;
    $[5] = phone;
    $[6] = tradingHours;
    $[7] = website;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const {
    isNotEmpty
  } = t1;
  let t2;
  if ($[9] !== logoLight || $[10] !== title) {
    t2 = <LogoTile logo={logoLight} alt={title} />;
    $[9] = logoLight;
    $[10] = title;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== title) {
    t3 = title && <h3 className="typography-component-sm-medium text-text-primary desktop:typography-component-md-medium">{title}</h3>;
    $[12] = title;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== t2 || $[15] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const cardBody = t4;
  let t5;
  if ($[17] !== cardBody || $[18] !== className || $[19] !== isNotEmpty || $[20] !== t || $[21] !== title) {
    t5 = isNotEmpty ? <button type="button" className={cn("group flex w-full cursor-pointer flex-col items-start gap-3 text-left desktop:gap-4", "focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-border-active", className)} data-testid="commercial-tenant-card" aria-label={t("openDetails", {
      name: title
    })}>{cardBody}</button> : <article className={cn("flex w-full flex-col items-start gap-3 desktop:gap-4", className)} data-testid="commercial-tenant-card">{cardBody}</article>;
    $[17] = cardBody;
    $[18] = className;
    $[19] = isNotEmpty;
    $[20] = t;
    $[21] = title;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  const trigger = t5;
  let t6;
  if ($[23] !== address || $[24] !== bodyCopy || $[25] !== email || $[26] !== facebook || $[27] !== instagram || $[28] !== phone || $[29] !== title || $[30] !== tradingHours || $[31] !== website) {
    t6 = <CommercialTenantDetailPanel title={title} address={address} tradingHours={tradingHours} bodyCopy={bodyCopy} website={website} email={email} phone={phone} facebook={facebook} instagram={instagram} />;
    $[23] = address;
    $[24] = bodyCopy;
    $[25] = email;
    $[26] = facebook;
    $[27] = instagram;
    $[28] = phone;
    $[29] = title;
    $[30] = tradingHours;
    $[31] = website;
    $[32] = t6;
  } else {
    t6 = $[32];
  }
  let t7;
  if ($[33] !== isNotEmpty || $[34] !== t6 || $[35] !== trigger) {
    t7 = <DialogCard enabled={isNotEmpty} trigger={trigger} panel={t6} contentClassName="desktop:max-w-[803px]" />;
    $[33] = isNotEmpty;
    $[34] = t6;
    $[35] = trigger;
    $[36] = t7;
  } else {
    t7 = $[36];
  }
  return t7;
}